import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as LogoName } from '../../../../assets/images/headerLogo/LogoName.svg';
import { ReactComponent as LogoInternal } from '../../../../assets/images/headerLogo/InternalCircleLogo.svg';
import { ReactComponent as LogoExternal } from '../../../../assets/images/headerLogo/OuterCircleLogo.svg';
import { BasicButton } from '../../buttons/BasicButton/BasicButton';

interface LogoProps {
  handleClose: () => void;
}

export const Logo: FC<LogoProps> = ({ handleClose }) => {
  const reloadPage = () => {
    handleClose();
    window.location.reload();
  };

  return (
    <BasicButton handleClick={reloadPage} className="logo-container">
      <NavLink to="/" className="logo-container__link">
        <LogoExternal className="outer" />
        <LogoInternal className="external" />
        <LogoName className="name" />
      </NavLink>
    </BasicButton>
  );
};
